import { createGlobalStyle } from 'styled-components';

/**
 * Design tokens — shared Affilers UI + partner-cabinet extensions.
 * Feature modules must use CSS variables; do not hardcode hex without need.
 * See docs/adr/0001-design-system.md
 */
export const GlobalTokensStyled = createGlobalStyle`
    :root {
        /* Shared core (aligned with affilers-admin-fe) */
        --app-bg-color: #131420;
        --app-bg-header-color: #1E1F30;
        --app-bg-modal-color: #262840;
        --app-bg-modal-header-color: #31324E;
        --app-bg-modal-panel-color: var(--color-surface-secondary);

        --color-base: #131420;
        --color-base-secondary: #1B1C2D;
        --color-surface: #262840;
        --color-surface-secondary: #31324E;
        --color-surface-highlight: #393C60;
        --color-main: #42456C;

        --color-accent: #FFDD3C;
        --color-yellow: #FFDD3C;
        --color-yellow-light: #FFEFA3;
        --color-yellow-dark: #A38600;
        --brand-color: #FFDD3C;

        --color-white: #FFFFFF;
        --color-white-60: rgba(255, 255, 255, 0.6);
        --color-white-95: rgba(255, 255, 255, 0.95);
        --text-color-secondary: #A3A6CC;
        --text-color-dark: #0A0A10;

        --color-positive: #54EEAB;
        --color-negative: #FF858B;
        --color-negative-lite: #FF999E;
        --color-green: #44A880;
        --color-green-secondary: #14C679;
        --color-red: #FF646C;
        --color-red-secondary: #D05257;

        --background-neutral-10: rgba(129, 146, 228, 0.1);
        --background-neutral-20: rgba(129, 146, 228, 0.2);
        --background-base: #0A0A10;

        --radius-sm: 4px;
        --radius-md: 8px;
        --radius-lg: 12px;

        --font-size-xs: 12px;
        --font-size-sm: 13px;
        --font-size-md: 14px;
        --font-size-base: 16px;
        --font-size-lg: 18px;
        --font-size-xl: 20px;
        --font-size-h4: 20px;
        --font-size-h3: 24px;
        --font-size-h2: 32px;
        --font-size-h1: 40px;

        --space-1: 4px;
        --space-2: 8px;
        --space-3: 12px;
        --space-4: 16px;
        --space-5: 20px;
        --space-6: 24px;

        --control-height: 40px;
        --control-height-sm: 32px;
        --control-height-lg: 48px;

        /* Partner cabinet extensions (existing modules depend on these) */
        --color-purple: #393C5D;
        --color-purple-highlight: #5F649B;
        --color-secondary: #BDC0DB;
        --color-secondary-active: #7D86B2;
        --color-secondary-highlight: #B9BFDF;
        --color-link: #3275F5;
        --color-black: #2A2B30;
        --icon-primary-color: #CAD0E7;
        --dx-bg-color: var(--color-surface-secondary);
    }
`;
